import { render, staticRenderFns } from "./tiga-notice-list.vue?vue&type=template&id=210cb4a0&scoped=true"
import script from "./tiga-notice-list.vue?vue&type=script&lang=js"
export * from "./tiga-notice-list.vue?vue&type=script&lang=js"
import style0 from "./tiga-notice-list.vue?vue&type=style&index=0&id=210cb4a0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210cb4a0",
  null
  
)

export default component.exports